import { lazy, Suspense } from "react";

import { Spinner } from "@app/components/spinners/spinner";

const ImporterExperimentalPageProjectStrategies = lazy(() => {
  return new Promise<{ default: React.FC }>((resolve, reject) => {
    import("experimental/lib")
      .then((lib) => {
        resolve({
          default: () => <lib.default.PageProjectStrategies />,
        });
      })
      .catch(reject);
  });
});

export const LazyExperimentalPageProjectStrategies = () => {
  return (
    <Suspense fallback={<Spinner height={"100vh"} />}>
      <ImporterExperimentalPageProjectStrategies />
    </Suspense>
  );
};
